export default "__VITE_ASSET__BER5yTON__"